module.exports = __webpack_public_path__ + "img/Steor-Icons-13.69c2acf7.svg";